import {Quiz} from "../../Shared/Model/QuizData";
import {Settings} from "../../Shared/Model/GameData";

export default class StringFactory {

    static quizTitle(quiz: Quiz, settings: Settings): string {
        return ["olympic-quiz-1-3", "olympic-quiz-4-8", "tourist-quiz-1-3", "tourist-quiz-4-8"].indexOf(quiz.id) !== -1 ? settings.name + " - " + quiz.name : quiz.name
    }
}
